import { getAllInquiries } from '../utils/api';
import { mockTestingFlagForAPI } from '../constants';
import { mockInquiries } from '../utils/mockData';
import {
  FETCH_INQUIRIES_STARTED,
  FETCH_INQUIRIES_SUCCESS,
  FETCH_INQUIRIES_FAILURE,
} from '.';

export const TTL_MS = 12 * 60 * 60 * 1000; // 12 hours

export function fetchInquiriesIfNeeded() {
  return async (dispatch, getState) => {
    const { status, fetchedAt } = getState().askVA.inquiriesHistory;

    // No-op if already loading
    if (status === 'loading') return;

    // No-op if cache is fresh
    if (status === 'success' && Date.now() - fetchedAt < TTL_MS) return;

    dispatch({ type: FETCH_INQUIRIES_STARTED });

    if (mockTestingFlagForAPI && !window?.Cypress) {
      dispatch({
        type: FETCH_INQUIRIES_SUCCESS,
        payload: mockInquiries.data,
        fetchedAt: Date.now(),
      });
      return;
    }

    try {
      const res = await getAllInquiries();
      dispatch({
        type: FETCH_INQUIRIES_SUCCESS,
        payload: res.data,
        fetchedAt: Date.now(),
      });
    } catch (e) {
      dispatch({ type: FETCH_INQUIRIES_FAILURE });
    }
  };
}
